import { styled } from "goober";
import { Link } from "./Link";

export const TabHeaderBar = styled("div")`
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--border-alpha);
`;

export const Tabs = styled("div")`
  display: flex;
  gap: 8px;
  padding: 12px;
  overflow: hidden;
`;

export const RightTabs = styled(Tabs)`
  margin-left: auto;
`;

export const Tab = styled(Link)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  border: none;
  text-decoration: none;
  outline: none;
  background: none;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 24px;
  cursor: pointer;

  color: var(--text-secondary);
  &.active {
    color: var(--text-primary);
  }

  --tab-hover-background:
    linear-gradient(var(--alpha4)), var(--surface-primary);
  --tab-background: var(--surface-primary);
  background: var(--tab-background);
  &.active,
  &:hover {
    --tab-background: var(--tab-hover-background);
  }
`;
